/**
 * Development-only logger utility.
 * In production builds, all log calls are no-ops to prevent
 * sensitive data (user IDs, booking hashes, PII) from leaking
 * into the browser console.
 */
const noop = (() => {}) as (...args: unknown[]) => void;

const isDev = import.meta.env.DEV;

export const logger = {
  log: isDev ? console.log.bind(console) : noop,
  warn: isDev ? console.warn.bind(console) : noop,
  error: console.error.bind(console), // Always log errors
  info: isDev ? console.info.bind(console) : noop,
  debug: isDev ? console.debug.bind(console) : noop,
};
